if(typeof _GIRL_CONF['twins']['game_memory']=='undefined'){_GIRL_CONF['twins']['game_memory']={};};
_GIRL_CONF['twins']['game_memory']['face1']={left:482,top:201,width:142,height:176};
_GIRL_CONF['twins']['game_memory']['face2']={left:697,top:204,width:147,height:174};
_GIRL_CONF['twins']['game_memory']['hair1']={left:275,top:44,width:445,height:489};
_GIRL_CONF['twins']['game_memory']['hair2']={left:624,top:62,width:382,height:357};
_GIRL_CONF['twins']['game_memory']['hand1']={left:424,top:371,width:363,height:291};
_GIRL_CONF['twins']['game_memory']['hand2']={left:538,top:354,width:368,height:372};
_GIRL_CONF['twins']['game_memory']['item1']={left:196,top:298,width:228,height:438};
_GIRL_CONF['twins']['game_memory']['item2']={left:961,top:408,width:146,height:293};
_GIRL_CONF['twins']['game_memory']['tit1']={left:480,top:407,width:165,height:115};
_GIRL_CONF['twins']['game_memory']['tit2']={left:671,top:421,width:149,height:118};
